export default __webpack_public_path__ + "static/media/5-mobile.6f93741c.webp";